import * as cx from 'classnames';
import range from 'lodash-es/range';
import { CONTEST_POSTS_OLD_CONTESTS, CONTEST_POSTS_TITLE } from 'mk/autogenerated/translations/ContestPosts.fe43e4cc4dc4027e96738da7d672eb80'
import { PostEntity, TopicEntity } from 'mk2/apps/forum/schemas';
import { forumPostDetail, forumTopic } from 'mk2/apps/forum/urls';
import Link from 'mk2/components/Link';
import LinkListItem, { LinkListItemPlaceholder } from 'mk2/components/LinkListItem';
import Panel from 'mk2/components/Panel';
import PanelHeading from 'mk2/components/PanelHeading';
import { url } from 'mk2/helpers/urls';
import * as React from 'react';
import styles from './ContestPosts.mscss';

interface OwnProps {
    className?: string;
    topic: TopicEntity;
    posts: PostEntity[];
}

type Props = OwnProps;

const ContestPosts: React.StatelessComponent<Props> = ({ className, topic, posts }) => (
    <Panel className={cx(styles.ContestPosts, className)}>
        <PanelHeading
            title={CONTEST_POSTS_TITLE}
            url={url(forumTopic, { topicSlug: topic.slug })}
        />
        <ul className={styles.ContestPosts__list}>
            {posts.map((post, index) => (
                <LinkListItem
                    key={post.id}
                    to={url(forumPostDetail, {topicSlug: post.topic.slug, postSlug: post.slug})}
                    title={(
                        <>
                            {post.heading}
                        </>
                    )}
                />
            ))}
        </ul>
        <Link className={styles.ContestPosts__more} to={url(forumTopic, { topicSlug: topic.slug })}>
            {CONTEST_POSTS_OLD_CONTESTS}
        </Link>
    </Panel>
);

ContestPosts.displayName = 'ContestPosts';

export default ContestPosts;

interface PlaceholderOwnProps {
    className?: string;
    length?: number;
}

export const ContestPostsPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ className, length = 3 }) => (
    <Panel className={cx(styles.ContestPosts, className)}>
        <PanelHeading title={CONTEST_POSTS_TITLE} />

        <ul className={styles.ContestPosts__list}>
            {range(length).map((idx) => (
                <LinkListItemPlaceholder key={idx} width={`${ [90, 85, 80, 70, 75, 85][idx % 6] }%`} />
            ))}
        </ul>
    </Panel>
);
